export const MAX_QUESTIONS = 10;
export const QUESTIONS_PER_PHASE = 4;

const LEVELS = ['elementary', 'middle', 'high'];

const curriculumByCountry = {
  us: {
    elementary: {
      label: 'Elementary School',
      phase1: [
        { id: 'us-el-p1-1', prompt: 'What is 7 + 5?', choices: ['10', '11', '12', '13'], correctIndex: 2 },
        { id: 'us-el-p1-2', prompt: 'Which shape has 4 equal sides?', choices: ['Triangle', 'Rectangle', 'Square', 'Circle'], correctIndex: 2 },
        { id: 'us-el-p1-3', prompt: 'What is 24 ÷ 6?', choices: ['3', '4', '5', '6'], correctIndex: 1 },
        { id: 'us-el-p1-4', prompt: 'What is one-half of 18?', choices: ['7', '8', '9', '10'], correctIndex: 2 },
      ],
      phase2: [
        { id: 'us-el-p2-1', prompt: 'What is 15 + 18?', choices: ['31', '32', '33', '34'], correctIndex: 2 },
        { id: 'us-el-p2-2', prompt: 'How many centimeters are in 1 meter?', choices: ['10', '50', '100', '1000'], correctIndex: 2 },
        { id: 'us-el-p2-3', prompt: 'What is 9 × 7?', choices: ['56', '63', '72', '81'], correctIndex: 1 },
        { id: 'us-el-p2-4', prompt: 'Which fraction is largest?', choices: ['1/4', '1/3', '1/2', '2/5'], correctIndex: 2 },
      ],
      recommendedUnits: ['Arithmetic Fluency', 'Fractions Basics', 'Geometry Foundations'],
    },
    middle: {
      label: 'Middle School',
      phase1: [
        { id: 'us-mid-p1-1', prompt: 'Solve: 3x + 5 = 20', choices: ['x = 3', 'x = 4', 'x = 5', 'x = 6'], correctIndex: 2 },
        { id: 'us-mid-p1-2', prompt: 'What is 20% of 150?', choices: ['20', '25', '30', '35'], correctIndex: 2 },
        { id: 'us-mid-p1-3', prompt: 'A triangle has angles 40° and 60°. Third angle?', choices: ['70°', '80°', '90°', '100°'], correctIndex: 1 },
        { id: 'us-mid-p1-4', prompt: 'Simplify: 4/12', choices: ['1/4', '1/3', '2/3', '3/4'], correctIndex: 1 },
      ],
      phase2: [
        { id: 'us-mid-p2-1', prompt: 'Solve: 2(x - 3) = 10', choices: ['x = 5', 'x = 6', 'x = 7', 'x = 8'], correctIndex: 3 },
        { id: 'us-mid-p2-2', prompt: 'What is the slope of line through (0,2) and (4,10)?', choices: ['1', '2', '3', '4'], correctIndex: 1 },
        { id: 'us-mid-p2-3', prompt: 'Find the area of a rectangle 9 by 7.', choices: ['56', '63', '72', '81'], correctIndex: 1 },
        { id: 'us-mid-p2-4', prompt: 'Which is equivalent to 0.125?', choices: ['1/4', '1/5', '1/8', '1/10'], correctIndex: 2 },
      ],
      recommendedUnits: ['Linear Equations', 'Ratios & Percentages', 'Geometry Applications'],
    },
    high: {
      label: 'High School',
      phase1: [
        { id: 'us-high-p1-1', prompt: 'Factor: x² - 9', choices: ['(x-3)(x+3)', '(x-9)(x+1)', '(x-1)(x-9)', 'Prime'], correctIndex: 0 },
        { id: 'us-high-p1-2', prompt: 'Solve: 2x² = 18', choices: ['x = ±3', 'x = 3 only', 'x = ±9', 'x = ±6'], correctIndex: 0 },
        { id: 'us-high-p1-3', prompt: 'What is sin(30°)?', choices: ['1', '1/2', '√3/2', '0'], correctIndex: 1 },
        { id: 'us-high-p1-4', prompt: 'If f(x)=2x+1, f(4)=?', choices: ['7', '8', '9', '10'], correctIndex: 2 },
      ],
      phase2: [
        { id: 'us-high-p2-1', prompt: 'Solve: log₁₀(1000)=?', choices: ['2', '3', '10', '100'], correctIndex: 1 },
        { id: 'us-high-p2-2', prompt: 'Derivative of x³ is:', choices: ['x²', '2x', '3x²', '3x'], correctIndex: 2 },
        { id: 'us-high-p2-3', prompt: 'Simplify: (x²y³)/(xy)', choices: ['xy²', 'x²y²', 'xy³', 'y²'], correctIndex: 0 },
        { id: 'us-high-p2-4', prompt: 'A sequence: 2, 6, 18,... next term?', choices: ['24', '36', '42', '54'], correctIndex: 3 },
      ],
      recommendedUnits: ['Functions & Graphs', 'Quadratics', 'Trigonometry'],
    },
  },
  france: {
    elementary: {
      label: 'École primaire',
      phase1: [
        { id: 'fr-el-p1-1', prompt: 'Combien font 9 + 6 ?', choices: ['13', '14', '15', '16'], correctIndex: 2 },
        { id: 'fr-el-p1-2', prompt: 'La moitié de 14 est...', choices: ['6', '7', '8', '9'], correctIndex: 1 },
        { id: 'fr-el-p1-3', prompt: 'Combien de côtés a un triangle ?', choices: ['2', '3', '4', '5'], correctIndex: 1 },
        { id: 'fr-el-p1-4', prompt: '30 ÷ 5 = ?', choices: ['5', '6', '7', '8'], correctIndex: 1 },
      ],
      phase2: [
        { id: 'fr-el-p2-1', prompt: '12 × 4 = ?', choices: ['36', '40', '48', '52'], correctIndex: 2 },
        { id: 'fr-el-p2-2', prompt: 'Quelle fraction est la plus grande ?', choices: ['1/5', '1/4', '1/3', '1/2'], correctIndex: 3 },
        { id: 'fr-el-p2-3', prompt: 'Un mètre = ... centimètres', choices: ['10', '50', '100', '1000'], correctIndex: 2 },
        { id: 'fr-el-p2-4', prompt: 'Quel nombre manque: 5, 10, 15, ...', choices: ['18', '20', '22', '25'], correctIndex: 1 },
      ],
      recommendedUnits: ['Calcul mental', 'Fractions simples', 'Mesures et géométrie'],
    },
    middle: {
      label: 'Collège',
      phase1: [
        { id: 'fr-mid-p1-1', prompt: 'Résoudre: x + 7 = 15', choices: ['6', '7', '8', '9'], correctIndex: 2 },
        { id: 'fr-mid-p1-2', prompt: '25% de 80 = ?', choices: ['10', '15', '20', '25'], correctIndex: 2 },
        { id: 'fr-mid-p1-3', prompt: 'Un angle droit mesure...', choices: ['45°', '60°', '90°', '180°'], correctIndex: 2 },
        { id: 'fr-mid-p1-4', prompt: 'Réduire: 18/24', choices: ['2/3', '3/4', '4/5', '5/6'], correctIndex: 1 },
      ],
      phase2: [
        { id: 'fr-mid-p2-1', prompt: 'Résoudre: 3x = 21', choices: ['5', '6', '7', '8'], correctIndex: 2 },
        { id: 'fr-mid-p2-2', prompt: 'Aire d’un rectangle 8 × 5 ?', choices: ['13', '26', '40', '80'], correctIndex: 2 },
        { id: 'fr-mid-p2-3', prompt: '0,4 en fraction simplifiée ?', choices: ['1/4', '2/5', '3/5', '4/5'], correctIndex: 1 },
        { id: 'fr-mid-p2-4', prompt: 'La pente de y = 2x + 1 est...', choices: ['1', '2', '3', '4'], correctIndex: 1 },
      ],
      recommendedUnits: ['Proportionnalité', 'Équations', 'Géométrie plane'],
    },
    high: {
      label: 'Lycée',
      phase1: [
        { id: 'fr-high-p1-1', prompt: 'Factoriser: x² - 16', choices: ['(x-4)(x+4)', '(x-8)(x+2)', '(x-2)(x-8)', 'Impossible'], correctIndex: 0 },
        { id: 'fr-high-p1-2', prompt: 'sin(30°) vaut...', choices: ['0', '1/2', '√3/2', '1'], correctIndex: 1 },
        { id: 'fr-high-p1-3', prompt: 'f(x)=3x-2, f(5)=?', choices: ['11', '12', '13', '15'], correctIndex: 2 },
        { id: 'fr-high-p1-4', prompt: 'Solution de x²=25 ?', choices: ['x=5', 'x=-5', 'x=±5', 'x=25'], correctIndex: 2 },
      ],
      phase2: [
        { id: 'fr-high-p2-1', prompt: 'Dérivée de x² ?', choices: ['x', '2x', 'x²', '2'], correctIndex: 1 },
        { id: 'fr-high-p2-2', prompt: 'log10(100) = ?', choices: ['1', '2', '10', '100'], correctIndex: 1 },
        { id: 'fr-high-p2-3', prompt: 'Suite 3, 6, 12, ... terme suivant ?', choices: ['18', '21', '24', '27'], correctIndex: 2 },
        { id: 'fr-high-p2-4', prompt: 'x² + 2x + 1 = ?', choices: ['(x+1)²', '(x-1)²', 'x(x+2)', 'x²+1'], correctIndex: 0 },
      ],
      recommendedUnits: ['Fonctions', 'Trigonométrie', 'Dérivation'],
    },
  },
  italy: {
    elementary: {
      label: 'Scuola primaria',
      phase1: [
        { id: 'it-el-p1-1', prompt: 'Quanto fa 8 + 7?', choices: ['14', '15', '16', '17'], correctIndex: 1 },
        { id: 'it-el-p1-2', prompt: 'La metà di 16 è...', choices: ['6', '7', '8', '9'], correctIndex: 2 },
        { id: 'it-el-p1-3', prompt: '24 ÷ 4 = ?', choices: ['5', '6', '7', '8'], correctIndex: 1 },
        { id: 'it-el-p1-4', prompt: 'Quanti lati ha un quadrato?', choices: ['3', '4', '5', '6'], correctIndex: 1 },
      ],
      phase2: [
        { id: 'it-el-p2-1', prompt: '11 × 3 = ?', choices: ['22', '33', '44', '55'], correctIndex: 1 },
        { id: 'it-el-p2-2', prompt: '1 metro equivale a...', choices: ['10 cm', '100 cm', '1000 cm', '50 cm'], correctIndex: 1 },
        { id: 'it-el-p2-3', prompt: 'Quale frazione è maggiore?', choices: ['1/4', '1/3', '2/3', '3/5'], correctIndex: 2 },
        { id: 'it-el-p2-4', prompt: 'Serie: 2, 4, 6, ...', choices: ['7', '8', '9', '10'], correctIndex: 1 },
      ],
      recommendedUnits: ['Calcolo di base', 'Frazioni', 'Figure geometriche'],
    },
    middle: {
      label: 'Scuola media',
      phase1: [
        { id: 'it-mid-p1-1', prompt: 'Risolvi: x + 9 = 14', choices: ['3', '4', '5', '6'], correctIndex: 2 },
        { id: 'it-mid-p1-2', prompt: '30% di 50 è...', choices: ['10', '15', '20', '25'], correctIndex: 1 },
        { id: 'it-mid-p1-3', prompt: 'Angolo retto = ...', choices: ['45°', '60°', '90°', '120°'], correctIndex: 2 },
        { id: 'it-mid-p1-4', prompt: 'Riduci 10/15', choices: ['1/2', '2/3', '3/4', '4/5'], correctIndex: 1 },
      ],
      phase2: [
        { id: 'it-mid-p2-1', prompt: 'Risolvi: 2x = 18', choices: ['7', '8', '9', '10'], correctIndex: 2 },
        { id: 'it-mid-p2-2', prompt: 'Area rettangolo 6 × 4?', choices: ['10', '20', '24', '28'], correctIndex: 2 },
        { id: 'it-mid-p2-3', prompt: '0,75 in frazione è...', choices: ['1/2', '2/3', '3/4', '4/5'], correctIndex: 2 },
        { id: 'it-mid-p2-4', prompt: 'Pendenza di y=3x+2 ?', choices: ['1', '2', '3', '4'], correctIndex: 2 },
      ],
      recommendedUnits: ['Equazioni lineari', 'Percentuali', 'Geometria'],
    },
    high: {
      label: 'Liceo',
      phase1: [
        { id: 'it-high-p1-1', prompt: 'Scomponi: x² - 4', choices: ['(x-2)(x+2)', '(x-4)(x+1)', '(x-1)(x-4)', 'Primo'], correctIndex: 0 },
        { id: 'it-high-p1-2', prompt: 'sin(30°) = ?', choices: ['0', '1/2', '√3/2', '1'], correctIndex: 1 },
        { id: 'it-high-p1-3', prompt: 'f(x)=2x+3, f(4)=?', choices: ['9', '10', '11', '12'], correctIndex: 2 },
        { id: 'it-high-p1-4', prompt: 'x²=36, soluzioni?', choices: ['x=6', 'x=-6', 'x=±6', 'x=36'], correctIndex: 2 },
      ],
      phase2: [
        { id: 'it-high-p2-1', prompt: 'Derivata di x³?', choices: ['x²', '2x', '3x²', '3x'], correctIndex: 2 },
        { id: 'it-high-p2-2', prompt: 'log10(1000)=?', choices: ['2', '3', '10', '100'], correctIndex: 1 },
        { id: 'it-high-p2-3', prompt: 'Serie 1, 3, 9, ...', choices: ['18', '21', '27', '30'], correctIndex: 2 },
        { id: 'it-high-p2-4', prompt: 'x² + 4x + 4 = ?', choices: ['(x+2)²', '(x-2)²', 'x(x+4)', 'x²+4'], correctIndex: 0 },
      ],
      recommendedUnits: ['Funzioni', 'Trigonometria', 'Derivate'],
    },
  },
  saudi: {
    elementary: {
      label: 'الابتدائية',
      phase1: [
        { id: 'sa-el-p1-1', prompt: 'ما ناتج 6 + 7 ؟', choices: ['11', '12', '13', '14'], correctIndex: 2 },
        { id: 'sa-el-p1-2', prompt: 'نصف العدد 20 هو...', choices: ['8', '9', '10', '11'], correctIndex: 2 },
        { id: 'sa-el-p1-3', prompt: '18 ÷ 3 = ?', choices: ['4', '5', '6', '7'], correctIndex: 2 },
        { id: 'sa-el-p1-4', prompt: 'كم ضلعًا للمربع؟', choices: ['3', '4', '5', '6'], correctIndex: 1 },
      ],
      phase2: [
        { id: 'sa-el-p2-1', prompt: '9 × 4 = ?', choices: ['28', '32', '36', '40'], correctIndex: 2 },
        { id: 'sa-el-p2-2', prompt: '1 متر يساوي...', choices: ['10 سم', '50 سم', '100 سم', '1000 سم'], correctIndex: 2 },
        { id: 'sa-el-p2-3', prompt: 'أي كسر أكبر؟', choices: ['1/5', '1/4', '1/3', '1/2'], correctIndex: 3 },
        { id: 'sa-el-p2-4', prompt: 'المتتالية 3، 6، 9، ...', choices: ['10', '11', '12', '13'], correctIndex: 2 },
      ],
      recommendedUnits: ['أساسيات الحساب', 'الكسور', 'الهندسة الأساسية'],
    },
    middle: {
      label: 'المتوسطة',
      phase1: [
        { id: 'sa-mid-p1-1', prompt: 'حل: x + 8 = 13', choices: ['3', '4', '5', '6'], correctIndex: 2 },
        { id: 'sa-mid-p1-2', prompt: '20% من 90 = ؟', choices: ['16', '18', '20', '22'], correctIndex: 1 },
        { id: 'sa-mid-p1-3', prompt: 'قياس الزاوية القائمة...', choices: ['45°', '60°', '90°', '120°'], correctIndex: 2 },
        { id: 'sa-mid-p1-4', prompt: 'بسط الكسر 12/18', choices: ['1/2', '2/3', '3/4', '4/5'], correctIndex: 1 },
      ],
      phase2: [
        { id: 'sa-mid-p2-1', prompt: 'حل: 3x = 27', choices: ['7', '8', '9', '10'], correctIndex: 2 },
        { id: 'sa-mid-p2-2', prompt: 'مساحة مستطيل 7 × 6 = ؟', choices: ['36', '40', '42', '48'], correctIndex: 2 },
        { id: 'sa-mid-p2-3', prompt: '0.5 يساوي الكسر...', choices: ['1/3', '1/2', '2/3', '3/4'], correctIndex: 1 },
        { id: 'sa-mid-p2-4', prompt: 'ميل المستقيم y=4x+1 هو...', choices: ['1', '2', '3', '4'], correctIndex: 3 },
      ],
      recommendedUnits: ['المعادلات الخطية', 'النسب المئوية', 'الهندسة المستوية'],
    },
    high: {
      label: 'الثانوية',
      phase1: [
        { id: 'sa-high-p1-1', prompt: 'حلل: x² - 25', choices: ['(x-5)(x+5)', '(x-25)(x+1)', '(x-1)(x-25)', 'أولي'], correctIndex: 0 },
        { id: 'sa-high-p1-2', prompt: 'قيمة sin(30°) هي...', choices: ['0', '1/2', '√3/2', '1'], correctIndex: 1 },
        { id: 'sa-high-p1-3', prompt: 'إذا f(x)=x+4 فإن f(6)=?', choices: ['8', '9', '10', '11'], correctIndex: 2 },
        { id: 'sa-high-p1-4', prompt: 'حل x²=49', choices: ['x=7', 'x=-7', 'x=±7', 'x=49'], correctIndex: 2 },
      ],
      phase2: [
        { id: 'sa-high-p2-1', prompt: 'مشتقة x² هي...', choices: ['x', '2x', 'x²', '2'], correctIndex: 1 },
        { id: 'sa-high-p2-2', prompt: 'log10(100)=?', choices: ['1', '2', '10', '100'], correctIndex: 1 },
        { id: 'sa-high-p2-3', prompt: 'المتتالية 2، 4، 8، ...', choices: ['10', '12', '14', '16'], correctIndex: 3 },
        { id: 'sa-high-p2-4', prompt: 'x² + 6x + 9 = ?', choices: ['(x+3)²', '(x-3)²', 'x(x+6)', 'x²+9'], correctIndex: 0 },
      ],
      recommendedUnits: ['الدوال', 'المثلثات', 'التفاضل'],
    },
  },
};

const fallbackCountry = curriculumByCountry.us;

export const getCountryCurriculum = (country) => {
  const normalized = (country || '').toLowerCase();
  return curriculumByCountry[normalized] || fallbackCountry;
};

export const getLevelFromEducation = (education = '') => {
  const normalized = education.toLowerCase();

  if (
    normalized.includes('elementary') ||
    normalized.includes('primaria') ||
    normalized.includes('primaire') ||
    normalized.includes('cp') ||
    normalized.includes('ce1') ||
    normalized.includes('ce2') ||
    normalized.includes('cm1') ||
    normalized.includes('cm2') ||
    normalized.includes('classe 1') ||
    normalized.includes('classe 2') ||
    normalized.includes('classe 3') ||
    normalized.includes('classe 4') ||
    normalized.includes('classe 5')
  ) {
    return 'elementary';
  }

  if (
    normalized.includes('middle') ||
    normalized.includes('medie') ||
    normalized.includes('media') ||
    normalized.includes('collège') ||
    normalized.includes('college') ||
    normalized.includes('6ème') ||
    normalized.includes('5ème') ||
    normalized.includes('4ème') ||
    normalized.includes('3ème')
  ) {
    return 'middle';
  }

  return 'high';
};

export const getLevelLabel = (country, level) => {
  const curriculum = getCountryCurriculum(country);
  return curriculum[level]?.label || curriculum.high.label;
};

const clampLevel = (level) => {
  if (!LEVELS.includes(level)) return 'middle';
  return level;
};

export const getPhaseQuestions = ({ country, level, phase }) => {
  const curriculum = getCountryCurriculum(country);
  const safeLevel = clampLevel(level);
  const levelConfig = curriculum[safeLevel] || curriculum.middle;
  const phasePool = levelConfig[phase] || [];
  return phasePool.slice(0, QUESTIONS_PER_PHASE);
};

const getAccuracyPercent = (correctCount, total) => {
  if (!total) return 0;
  return (correctCount / total) * 100;
};

export const getAdjustedLevel = (phase1Percent, baseLevel) => {
  const safeBase = clampLevel(baseLevel);
  const index = LEVELS.indexOf(safeBase);

  if (phase1Percent <= 40) {
    return LEVELS[Math.max(0, index - 1)];
  }

  if (phase1Percent >= 80) {
    return LEVELS[Math.min(LEVELS.length - 1, index + 1)];
  }

  return safeBase;
};

export const computeDiagnosticResult = ({
  country,
  baseLevel,
  phase1Correct,
  phase2Correct,
  phase1Total,
  phase2Total,
}) => {
  const safeBaseLevel = clampLevel(baseLevel);
  const phase1Percent = getAccuracyPercent(phase1Correct, phase1Total);
  const adjustedLevel = getAdjustedLevel(phase1Percent, safeBaseLevel);
  const totalCorrect = phase1Correct + phase2Correct;
  const totalQuestions = phase1Total + phase2Total;
  const totalPercent = getAccuracyPercent(totalCorrect, totalQuestions);

  let finalLevel = adjustedLevel;
  const baseIndex = LEVELS.indexOf(safeBaseLevel);
  const adjustedIndex = LEVELS.indexOf(adjustedLevel);

  if (totalPercent >= 80) {
    finalLevel = LEVELS[Math.min(LEVELS.length - 1, Math.max(baseIndex, adjustedIndex) + 1)];
  } else if (totalPercent <= 40) {
    finalLevel = LEVELS[Math.max(0, Math.min(baseIndex, adjustedIndex) - 1)];
  }

  const finalIndex = LEVELS.indexOf(finalLevel);
  const classification = finalIndex < baseIndex
    ? 'Below expected level'
    : finalIndex > baseIndex
      ? 'Above expected level'
      : 'At expected level';

  const confidenceScore = Math.round(
    Math.min(
      99,
      Math.max(
        50,
        55 + Math.abs(totalPercent - 50) * 0.8 + Math.min(totalQuestions, MAX_QUESTIONS) * 2,
      ),
    ),
  );

  const curriculum = getCountryCurriculum(country);
  const recommendedUnits = curriculum[finalLevel]?.recommendedUnits || [];

  return {
    baseLevel: safeBaseLevel,
    phase1Percent,
    adjustedLevel,
    totalPercent,
    estimatedSchoolLevel: getLevelLabel(country, finalLevel),
    estimatedLevelKey: finalLevel,
    confidenceScore,
    classification,
    recommendedUnits,
    totalQuestions,
    totalCorrect,
  };
};
